export default __webpack_public_path__ + "static/media/ntionality.7fba545b.png";